/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Clear_MarkerInputs */



/**
* | output |
* | --- |
* | "Captions cleared" |
*
* @param {Live_Caption_Clear_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_clear_marker = /** @type {((inputs?: Live_Caption_Clear_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Clear_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres effacés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel entfernt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli cancellati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры очищены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos eliminados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕已清除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕承認済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन साफ़ हो गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas removidas")
	return /** @type {LocalizedString} */ ("Captions cleared")
});